/**
 * Removes all whitespace characters from a SIRET string
 * @param value - The SIRET value that may contain spaces
 * @returns The SIRET value with all spaces removed
 */
export function removeSiretSpaces(value: string | undefined | null): string {
  if (!value || typeof value !== 'string') {
    return '';
  }
  return value.replace(/\s/g, '');
}
